import type { User } from '@lmc/ts-common'
import GroupedOptionsMultiSelect from './GroupedOptionsMultiSelect'

// We had to this workaround as @lmc/ts-common has issues with permissions
type GroupUSer = User & any

type GroupedUsersMultiSelectProps = {
  users: GroupUSer[]
  title: string
  values?: string[]
  handleInputChange?: (newValue: any) => void
  [key: string]: any
}

const GroupedUsersMultiSelect = ({
  users,
  title,
  values,
  handleInputChange,
  ...props
}: GroupedUsersMultiSelectProps) => {
  const groupedUsers: { [status: string]: User[] } = {
    active: [],
    inactive: []
  }

  users?.forEach((user: GroupUSer) => {
    if (user.active) {
      groupedUsers.active.push(user)
    } else {
      groupedUsers.inactive.push(user)
    }
  })

  return (
    <GroupedOptionsMultiSelect
      groupedOptions={groupedUsers}
      title={title}
      values={values}
      handleInputChange={(newValue: any) => handleInputChange?.(newValue)}
      {...props}
    />
  )
}

export default GroupedUsersMultiSelect
